import { type ApolloError, useSubscription } from '@apollo/client'
import { useState } from 'react'

import { useUser } from '@/client/context/user'
import { useIsPageVisible } from '@/client/hooks'
import {
  LIVE_HELP_REQUESTS_SUBSCRIPTION_FOR_POST,
  LIVE_HELP_REQUESTS_SUBSCRIPTION_FOR_USER,
} from '@/client/services/hasura/queries'

import { liveHelpRequestWithNullableSessionDetailsFromFragment } from '../../transforms/detailsFromFragments'
import type { LiveHelpRequestWithNullableSessionDetails } from '../../types'

export default function useRealtimeLiveHelpRequests(postId?: number): {
  loading: boolean
  error: ApolloError | null
  liveHelpRequests: LiveHelpRequestWithNullableSessionDetails[]
} {
  const user = useUser()
  const isPageVisible = useIsPageVisible()

  const [liveHelpRequests, setLiveHelpRequests] = useState<
    LiveHelpRequestWithNullableSessionDetails[] | null
  >(null)

  const { loading, error = null } = useSubscription(
    postId != null
      ? LIVE_HELP_REQUESTS_SUBSCRIPTION_FOR_POST
      : LIVE_HELP_REQUESTS_SUBSCRIPTION_FOR_USER,
    {
      skip: !isPageVisible,
      variables:
        postId != null
          ? { postId, sessionRegistrationUserId: user.id }
          : { sessionRegistrationUserId: user.id },
      onData: data => {
        const liveHelpRequestFragments = data.data.data?.live_help_request ?? []
        setLiveHelpRequests(
          liveHelpRequestFragments.map(liveHelpRequestWithNullableSessionDetailsFromFragment)
        )
      },
    }
  )

  return {
    loading: loading && liveHelpRequests == null,
    error,
    liveHelpRequests: liveHelpRequests ?? [],
  }
}
